import { useCallback, useEffect, useState } from 'react'
import type { BoardTemplateDocument } from '@/types'
import { toUserFacingError } from '@/lib/errors'
import { boardTemplatesService } from '../services/boardTemplates.service'

type Loaded = BoardTemplateDocument & { id: string }

export function useBoardTemplates() {
  const [templates, setTemplates] = useState<Loaded[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const reload = useCallback(async () => {
    setLoading(true)
    try {
      setTemplates(await boardTemplatesService.list())
      setError(null)
    } catch (e) {
      setError(toUserFacingError(
        e,
        'We could not load board templates. Please try again.',
        'project-board-templates/load',
      ))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void reload()
  }, [reload])

  return { templates, loading, error, reload }
}
